import {
  ATTACHMENT_UPLOAD,
  ATTACHMENT_DOWNLOAD,
  ATTACHMENT_REQUEST,
  ATTACHMENT_SUCCESS,
  ATTACHMENT_ERROR
} from "@/store/types"

import axios from "@/store/axios"
import { saveAs } from "file-saver"
import btoa from "btoa"

const state = {
  isLoading: false,
  error: null
}

const getters = {
  isAttachmentLoading: (state) => state.isLoading,
  getAttachmentError: (state) => state.error
}

const actions = {
  [ATTACHMENT_UPLOAD]: ({ commit }, { file }) => {
    return new Promise((resolve, reject) => {
      commit(ATTACHMENT_REQUEST)

      const formData = new FormData()
      formData.append("attachment", file)

      axios
        .post(`/api/v3/attachments/upload/`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(ATTACHMENT_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(ATTACHMENT_ERROR, err)
          reject(err)
        })
    })
  },
  [ATTACHMENT_DOWNLOAD]: ({ commit }, { path, save = true }) => {
    return new Promise((resolve, reject) => {
      commit(ATTACHMENT_REQUEST)

      const encodedPath = encodeURIComponent(btoa(unescape(encodeURIComponent(path))))

      axios
        .get(`/api/v3/attachments/download?path=${encodedPath}`, {
          responseType: "blob"
        })
        .then((resp) => {
          if (save) {
            saveAs(resp.data, path.replace("form-uploads/", ""))
          }

          commit(ATTACHMENT_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          console.log(err)
          commit(ATTACHMENT_ERROR, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [ATTACHMENT_REQUEST]: (state) => {
    state.isLoading = true
  },
  [ATTACHMENT_SUCCESS]: (state) => {
    state.isLoading = false
  },
  [ATTACHMENT_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
